export default "__VITE_ASSET__PpZG0IDQ__"